/* eslint-disable react/prop-types */
import React from 'react';

type TriangleProps = { size?: number; color?: string } & React.SVGProps<SVGSVGElement>;

function Triangle({ size, color, opacity }: TriangleProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 6 6">
            <path
                fill={color}
                fillRule="evenodd"
                d="M2.098 4.643L.152 1.53A1 1 0 0 1 1 0h3.892a1 1 0 0 1 .848 1.53L3.794 4.643a1 1 0 0 1-1.696 0z"
                opacity={opacity}
            />
        </svg>
    );
}

export default Triangle;
